import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { configureStore } from 'src/app/redux/store';

import 'src/leaflet.css';
import 'src/antd.css';
import 'src/index.scss';

import LocalizationWrapper from './app/LocalizationWrapper';
import i18n from './i18n';

const store = configureStore();

const currentLanguage = i18n.language || 'en';
document.documentElement.lang = currentLanguage;
document.documentElement.dir = i18n.dir();

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = i18n.dir();
});

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <LocalizationWrapper />
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root'),
);
